import { Box, Typography } from "@mui/material"

const hasMeaningfulHtml = (html) => {
  if (!html) return false
  const text = String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .trim()
  return Boolean(text)
}

export default function PaymentInstructions({
  short = false,
  headerSx,
  instructionsHtml,
}) {
  const htmlToRender = hasMeaningfulHtml(instructionsHtml) ? instructionsHtml : ""

  if (!htmlToRender) return null

  return (
    <Box>
      {!short && (
        <Typography
          sx={{
            color: "text.primary",
            fontSize: 16,
            fontWeight: 600,
            mb: 2,
            ...headerSx,
          }}
        >
          Please follow the venue payment instructions below.
        </Typography>
      )}

      <Box
        sx={{
          color: "text.primary",
          fontSize: short ? 14 : 15,
          lineHeight: 1.7,
          "& > *": { mb: 1 },
          "& b, & strong": { color: "text.primary", fontWeight: 700 },
        }}
        dangerouslySetInnerHTML={{ __html: htmlToRender }}
      />
    </Box>
  )
}
